/* hp-thumb-fit.js — Galerie-Thumbnails: Formate-Regel (Entscheid Tobias 2026-07-30,
 * Artifact «PDP-Thumbnails: Formate-Konzept» v2, Memory pdp-thumbnails-formate).
 *
 * Regel: PRODUKTBILDER (weisser oder durchsichtiger Hintergrund) bleiben zu 100%
 * unangetastet — an ihnen ändert sich kein Pixel. NUR Lifestyle-Fotos und
 * Video-Vorschaubilder werden in die Kachel gezoomt (object-fit: cover), damit
 * die grauen Balken bei Hoch-/Querformaten verschwinden.
 *
 * Erkennung pro Bild (einmalig, Ergebnis pro Session gecacht): 6 Randpunkte des
 * Thumbnails (150px-Variante) — sind mindestens 5 davon weiss ODER durchsichtig,
 * gilt das Bild als Produktbild. Shopify-CDN liefert CORS-Header, darum ist der
 * Canvas-Pixel-Check mit crossOrigin=anonymous möglich. Bei jedem Fehler
 * (Canvas tainted, Netz, decode) passiert NICHTS — Fallback ist immer das
 * heutige Verhalten (contain), es kann also nie schlechter werden als vorher.
 *
 * Die Thumb-Leiste wird vom Theme/Varianten-Bilderfilter re-rendert (lazy
 * loading, Variantenwechsel) → MutationObserver wendet die Klasse erneut an.
 * Plain ES5 IIFE, keine Dependencies.
 */
(function () {
  if (window.__hpThumbFitInstalled) return;
  window.__hpThumbFitInstalled = true;

  var CACHE_KEY = 'hpThumbFit.v1';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}') || {}; } catch (e) { cache = {}; }
  var saveT = null;
  function saveCache() {
    clearTimeout(saveT);
    saveT = setTimeout(function () {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
    }, 400);
  }

  // Normalisierter Cache-Schlüssel: Pfad ohne Query (width-Varianten teilen das Urteil).
  function keyFor(src) {
    try { return src.split('?')[0]; } catch (e) { return src; }
  }

  // true = Produktbild (nicht anfassen), false = Foto/Video (cover), null = unbekannt.
  function classify(src, done) {
    var k = keyFor(src);
    if (k in cache) { done(cache[k]); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var result = null;
      try {
        var c = document.createElement('canvas');
        c.width = im.naturalWidth; c.height = im.naturalHeight;
        var ctx = c.getContext('2d');
        ctx.drawImage(im, 0, 0);
        var w = c.width, h = c.height;
        var pts = [[2, 2], [w - 3, 2], [2, h - 3], [w - 3, h - 3], [Math.floor(w / 2), 2], [Math.floor(w / 2), h - 3]];
        var clean = 0;
        for (var i = 0; i < pts.length; i++) {
          var d = ctx.getImageData(pts[i][0], pts[i][1], 1, 1).data;
          if (d[3] < 250 || (d[0] > 242 && d[1] > 242 && d[2] > 242)) clean++;
        }
        result = clean >= 5;
      } catch (e) { result = null; }
      cache[k] = result;
      saveCache();
      done(result);
    };
    im.onerror = function () { cache[k] = null; saveCache(); done(null); };
    im.src = src;
  }

  function apply() {
    var imgs = document.querySelectorAll('.media-thumbs__btn img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        var src = img.currentSrc || img.src;
        if (!src || img.getAttribute('data-hp-fit') === src) return;
        img.setAttribute('data-hp-fit', src);
        classify(src, function (isProduct) {
          // false = Foto/Video → zoomen; true/null = unangetastet lassen.
          img.classList.toggle('hp-thumb--cover', isProduct === false);
        });
      })(imgs[i]);
    }
  }

  function init() {
    var strip = document.querySelector('.media-gallery__thumbs');
    if (!strip) return;
    apply();
    try {
      new MutationObserver(function () { apply(); }).observe(strip, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
